<template>
  <v-data-table
    dense
    :headers="headers"
    :items="desserts"
    sort-by="summ_from"
    class="elevation-1"
  >
    <template v-slot:top>
      
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.summ_from" label="Сумма от"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.summ_to" label="Сумма по"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.days_from" label="Дней с"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.days_to" label="Дней по"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.value" label="Значение"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn outlined color="blue darken-1" text @click="close">Закрыть</v-btn>
              <v-btn  outlined color="blue darken-1" text @click="save">Записать</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      
    </template>
    <!-- <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        edit
      </v-icon>
    </template> -->
    
  </v-data-table>
</template>
    

<script>
  import Swal from "sweetalert2";
  export default {
    data: () => ({
      dialog: false,
      editedItem: {},
      formTitle: "Редактировать Базовый тариф",
      headers: [
        { text: "Сумма от", value: "summ_from" },
        { text: "Сумма до", value: "summ_to" },
        { text: "Дней от", value: "days_from" },
        { text: "Дней до", value: "days_to" },
        { text: "Значение", value: "value" },
        // { text: "Действия", value: "action" }
      ],
      
    }),

    computed: {
      desserts() {
        return this.$store.getters.getBT;
      },
      
    },

    

    created () {
      //this.initialize()
    },

    methods: {
      close() {},
      save() {},
      getBool(val) {
        if(val) return "Да"
        else return "Нет"
      },
      getColor(color) {
        if(color) return "red";
        return "transparent";
      },


      editItem (item) {
        const Arr = {
            id: item.id,
            name: item.name,
            active: item.active
        };
        this.$store
        .dispatch("getSituationCS", Arr)
        .then(() => {
          this.$router.push({ name: "editsituation" });
        })
        .catch(error => {
          alert(error);
        });
        
      },

      deleteItem (item) {
        Swal.fire({
          icon: "error",
          title: "Ошибка удаления",
          text: "Эта возможность пока еще не активирована"
        });
      },

      
    },
  }
</script>